<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	<div class="filter_options">
		<div class="row align-items-center">
			<div><h3>{{"Management.Filters" | translate}}</h3></div>
			<div class="float_end"><span class="result_count">{{"Management.ResultCnt" | translate}}: {{totalCount}}</span></div>
		</div>
		
		<div class="row align-items-end">
			<!-- <div class="mb-3">
				<label class="col-form-label">Search</label>
				<input type="text" class="form-control" id="" name="" placeholder="search text">
			</div> -->
			<!-- <div class="mb-3">
				<label class="col-form-label">{{"SelectSystem" | translate}}</label>
				<select class="form-select" id="" name="" [(ngModel)]="selectedSystemId">
					<option value="-1">{{"All" | translate}}</option>
					<option value="1">MPJ</option>
				</select>
			</div> -->
			<div class="mb-3">
				<label class="col-form-label">{{"Supplierbranch" | translate}}:</label>
				<select 
                class="form-select" 
                [(ngModel)]="selectedBranch"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let branch of branchDropdown" [value]="branch.branchId">
                        {{branch.branchName}}
                    </option>
                </select>
			</div>
            <div class="mb-3">
				<label class="col-form-label" style="display: block;">{{"Company" | translate}}:</label>
				<!-- <p-autoComplete
				
					[(ngModel)]="selectedCustomer"
					[suggestions]="filteredCustomers"
					(completeMethod)="filterCustomer($event)"
					optionLabel="customerName"
					[dropdown]="false"
					placeholder=""
					[forceSelection]="true"
					(onSelect)="onSelectCustomer($event)">
				</p-autoComplete> -->
				<select 
                class="form-select" 
                [(ngModel)]="selectedCustomer"
                aria-label="Month selection">
                    <option value="-1"> {{"All" | translate}}</option>
                    <option *ngFor="let customer of customerDropdown" [value]="customer.customerID">
                        {{customer.customerName}}
                    </option>
                </select>
			</div>
            <!-- <div class="mb-3">
				<label class="col-form-label">{{"SelectSupplier" | translate}}</label>
				<select class="form-select" id="" name="" [(ngModel)]="selectedSupplierId">
					<option value="-1">{{"All" | translate}}</option>
					<option value="1">{{"SupplierName" | translate}}</option>
				</select>
			</div> -->
            
            <div class="mb-3">
				<label class="col-form-label">{{"Management.UserType" | translate}}</label>
				<select class="form-select" id="" name="" [(ngModel)]="userType">
					<option value="1">{{"Management.Resource" | translate}}</option>
					<option value="10">{{"Management.Approve" | translate}}</option>
					<option value="100">{{"ServiceRep" | translate}}</option>
					<option value="500">{{"BranchManager" | translate}}</option>
				</select>
			</div>
			<div class="mb-3">
				<label class="col-form-label">{{"Management.Status" | translate}}</label>
				<select class="form-select" id="" name="" [(ngModel)]="selectStatus">
					<option value="-1">{{"All" | translate}}</option>
					<option value="1">{{"Management.Enabled" | translate}}</option>
					<option value="0">{{"Management.Disabled" | translate}}</option>
				</select>
			</div>
			<div class="mb-3">
				<button type="button" class="btn btn-primary" (click)="searchAssociates()">{{"Management.Search" | translate}}</button>
				<button type="button" class="btn btn-primary" (click)="clearAll()">{{"Management.ClearAll" | translate}}</button>
			</div>
		</div>
	</div>

	<!-- <div class="actio_button_area">
		<button class="butn download_entry btn">Download</button>
		<button class="butn approve_entry btn">Approve All</button>
	</div> -->
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
			<span aria-hidden="true">&times;</span>
			</button>
		</div>
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list">		
		<p-table 
        #dt2
        [value]="associatesList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['customerName', 'loginId', 'email2']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)">
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                <p-iconfield iconPosition="left" class="ml-auto">                        
                    <label>{{"Management.srchLabel" | translate}}:</label>
                    <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'Management.srchKey' | translate}}" />
                </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
                <!-- <thead> -->
                   
                    <tr class="tbl_head">                        
                        <th class="bor_lft_none">{{"Management.Name" | translate}}</th>
                        <th>{{"Management.LoginID" | translate}}</th>
                        <th>{{"Management.UserType" | translate}}</th>
                        <th>{{"Management.Status" | translate}}</th>
                        <th>{{"Management.CngStatus" | translate}}</th>
                        <th>{{"Management.Email" | translate}}</th>
                        <th>{{"Management.Options" | translate}}</th>
                    </tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                	<td>{{item.customerName}}</td>
                    <td>{{item.loginId}}</td>
                    <!-- <td>{{item.approver}}</td> -->
                    <td>{{item.userRole}}</td>
                    <td>{{(item.status)?"Enabled":"Disabled"}}</td>
                    <td>
						<label class="switch" *ngIf="(item.userRole == 'Resource')">
							<input type="checkbox" [(ngModel)]="item.status" (click)="cngStatus($event, item.userId)">
							<span class="slider"></span>
						</label>
					</td>
                    <td>{{item.email2}}</td>
                    <td>
						<div class="reject_save">
							<button *ngIf="!item.isPasswordReset && item.showResetBtn" class="btn btn-primary btn-sm change_pass" title="{{'Management.resetPwd' | translate}}" id="item.userId" [style.display]="isVisible ? 'block' : 'none'" (click)="restPassword(item)"><i class="bi bi-arrow-clockwise"></i> <i class="bi bi-key-fill"></i></button>
							<span *ngIf="item.isPasswordReset">{{"Management.restRequested" | translate}}</span>
							<!-- <button class="btn btn-primary btn-sm change_pass" title="{{'Management.resetPwdPwd' | translate}}" *ngIf="!item.isPasswordBlank"><i class="bi bi-arrow-clockwise"></i> <i class="bi bi-key-fill"></i></button>
							<button class="btn btn-primary btn-sm reset_pass" title="{{'Management.cngPassword' | translate}}"><i class="bi bi-arrow-repeat"></i> <i class="bi bi-key-fill"></i></button> -->
						</div>
					</td>
                </tr>
            </ng-template>                       
        <!-- </table> -->
        </p-table>
	</div>
	
	<!--  ############### Data Table End ################# -->
	
</div>
<!--  ############### Middle Containt Area End ################# -->